import { Component, Input } from '@angular/core';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss'],
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, NgIf, MatButton, MatIcon],
})
export class FilterItemComponent {
  currentValue = '';

  @Input() title!: string;

  @Input() set value(value: string | undefined) {
    if (value) {
      this.currentValue = value.split(',').join(', ');
    } else {
      this.currentValue = '';
    }
  }

  @Input() clearFilter!: () => void; //TODO: Why it is input and not EventEmmiter??

  onClearClick(event: Event) {
    event.stopPropagation();
    this.clearFilter();
  }
}
